import { Link } from "react-router-dom";

function Unauthorized() {
    return (
        <main>
            <div className="container">
                <section className="section error-404 min-vh-100 d-flex flex-column align-items-center justify-content-center">
                    <h1>401</h1>
                    <h2>Vous n'êtes pas autorisés à accéder à cette page.</h2>
                    <Link className="btn" to={process.env.REACT_APP_ADMIN_URL+"/dashboard"}>Back to home</Link>
                    {/* <img src="assets/img/not-found.svg" className="img-fluid py-5" alt="Page Not Found" /> */}
                    <div className="credits">
                    </div>
                </section>

            </div>
        </main>
    );
}
export default Unauthorized;